export default [
  {
    path: '/admin/project-packages',
    name: 'ProjectPackages',
    component: () => import('@/views/Admin/Project_packages/Index.vue'),
    meta: {
      pageTitle: 'Paketler',
      breadcrumb: [
        {
          text: 'Listele',
          active: true,
        },
      ],
      resource: 'ADMIN_PROJECT_PACKAGES',
      action: 'read',
    },
  },
  {
    path: '/admin/project-packages/add',
    name: 'ProjectPackageAdd',
    component: () => import('@/views/Admin/Project_packages/Add.vue'),
    meta: {
      pageTitle: 'Paketler',
      breadcrumb: [
        {
          text: 'Listele',
          to: '/admin/project-packages',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_PROJECT_PACKAGES_ADD',
      action: 'read',
    },
  },
  {
    path: '/admin/project-packages/edit/:id',
    name: 'ProjectPackageEdit',
    component: () => import('@/views/Admin/Project_packages/Edit.vue'),
    meta: {
      pageTitle: 'Paketler',
      breadcrumb: [
        {
          text: 'Listele',
          to: '/admin/project-packages',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_PROJECT_PACKAGES_EDIT',
      action: 'read',
    },
  },
]
